import { cn } from '@/lib/cn'
import { useLocation } from '@tanstack/react-router'
import { Sparkles, X } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'

const MODULE_DESCRIPTIONS: Record<string, { label: string; hint: string }> = {
  '/hr': {
    label: 'Ressources Humaines',
    hint: 'Gérez vos employés, contrats et congés.',
  },
  '/payroll': {
    label: 'Paie',
    hint: 'Calculez et validez les bulletins mensuels.',
  },
  '/accounting': {
    label: 'Comptabilité',
    hint: 'Grand livre SYSCOHADA et états financiers.',
  },
  '/finance': {
    label: 'Finance',
    hint: 'Facturation et encaissements clients.',
  },
  '/settings': {
    label: 'Paramètres',
    hint: 'Configuration de votre organisation et accès.',
  },
  '/customs': {
    label: 'Dédouanement',
    hint: 'Du dossier à la note de détail : devise, articles, liquidation.',
  },
  '/my': {
    label: 'Mon espace',
    hint: 'Pointage, congés et bulletins en self-service.',
  },
}

export function ModuleOnboardingBanner() {
  const location = useLocation()
  const [visible, setVisible] = useState(false)

  const { moduleKey, mod, storageKey } = useMemo(() => {
    const key = Object.keys(MODULE_DESCRIPTIONS).find(
      (k) => location.pathname === k || location.pathname.startsWith(`${k}/`),
    )
    return {
      moduleKey: key,
      mod: key ? MODULE_DESCRIPTIONS[key] : null,
      storageKey: key ? `amanet_onboarding_${key.replace(/\//g, '_')}` : null,
    }
  }, [location.pathname])

  useEffect(() => {
    if (!storageKey) {
      setVisible(false)
      return
    }
    const dismissed = localStorage.getItem(storageKey)
    setVisible(!dismissed)
  }, [storageKey])

  if (!visible || !mod || !moduleKey || !storageKey) return null

  const dismiss = () => {
    setVisible(false)
    localStorage.setItem(storageKey, '1')
  }

  return (
    <div
      className={cn(
        'flex items-center gap-3 border-b border-border bg-muted px-4 py-2.5 text-sm md:px-6',
        'dark:border-border',
      )}
    >
      <Sparkles className="h-3.5 w-3.5 flex-shrink-0 text-muted-foreground" />
      <p className="flex-1 text-xs text-muted-foreground">
        <span className="font-medium text-foreground">{mod.label}</span>
        {' — '}
        {mod.hint}
        <span className="ml-1 hidden text-muted-foreground md:inline">
          Cliquez sur le « ? » en haut à droite pour le guide complet.
        </span>
      </p>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Fermer"
        className="flex-shrink-0 text-muted-foreground hover:text-foreground"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
